module.exports = __webpack_public_path__ + "static/media/faisal.0b02d611.webp";